<template>
	<ConfirmationDialog class="delete-key-result-prompt">
		<template #header>
			<h1 class="delete-key-result-prompt__heading">{{ $t( "common-gokr.components.DeleteKeyResultPrompt.title" ) }}</h1>
		</template>
		<template #description>
			<main class="delete-key-result-prompt__main">
				{{ $t( "common-gokr.components.DeleteKeyResultPrompt.description" ) }}
			</main>
		</template>
		<template #actions>
			<footer class="delete-key-result-prompt__footer">
				<TeamingButton
					size="SMALL"
					type="PRIMARY"
					:destructive="true"
					@click="$emit( `confirm` )"
				>
					{{ $t( "common-gokr.components.DeleteKeyResultPrompt.confirmButton" ) }}
				</TeamingButton>
				<TeamingButton
					size="SMALL"
					type="QUATERNARY"
					@click="$emit( `dismiss` )"
				>
					{{ $t( "common-gokr.components.DeleteKeyResultPrompt.dismissButton" ) }}
				</TeamingButton>
			</footer>
		</template>
	</ConfirmationDialog>
</template>

<script>
import { ConfirmationDialog, TeamingButton } from "@teaming/common-ui";
export default {
	name: "DeleteKeyResultPrompt",
	emits: [ "confirm", "dismiss", ],
	components: {
		ConfirmationDialog,
		TeamingButton,
	},
};
</script>

<style lang="scss" scoped>
$delete-key-result-prompt-title-color: $color1-700;

.delete-key-result-prompt__heading {
	@include font-and-line-for(1);
	font-weight: 600;
	color: $delete-key-result-prompt-title-color;
}

.delete-key-result-prompt__footer {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 1rem;
}
</style>
